import React, { useEffect, useState } from 'react';
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Space,
  Button,
  Drawer,
  Checkbox
} from '@lockerpm/design';

import {
  CheckCircleOutlined,
  ArrowRightOutlined
} from '@ant-design/icons';

import itemsComponents from '../../../../../components/items';

import global from '../../../../../config/global';
import { downloadCSV } from '../../../../../utils/common'

function FormData(props) {
  const { TextCopy } = itemsComponents;
  const {
    visible = false,
    response = null,
    onClose = () => {},
  } = props
  const { t } = useTranslation()

  const [alreadySaved, setAlreadySaved] = useState(false)

  useEffect(() => {
    setAlreadySaved(false)
  }, [visible])

  const handleDownload = () => {
    const rows = [
      [t('access_key.id'), t('access_key.secret_key')],
      [response?.id, response?.access_key]
    ]
    downloadCSV(rows)
    onClose()
  }

  return (
    <div className={props.className}>
      <Drawer
        title={t('button.new_access_key')}
        placement="right"
        onClose={() => {}}
        open={visible}
        closable={false}
        footer={
          <Space className='flex items-center justify-end'>
           <Button
              type="primary"
              disabled={!alreadySaved}
              onClick={() => onClose()}
            >
              {t('button.done')} 
            </Button>
          </Space>
        }
      >
        <div className='h-full flex flex-col justify-between'>
          <div>
            <p className='font-bold'>{t('access_key.id')}</p>
            <TextCopy
              value={response?.id}
            />

            <p className='font-bold mt-6'>{t('access_key.secret_key')}</p>
            <TextCopy
              value={response?.access_key}
              onCopy={() => setAlreadySaved(true)}
            />

            <div className='mt-1'>
              <a
                className="flex items-center w-max"
                target={"_blank"}
                href={global.urls.PASSWORD_MANAGER_URL}
              >
                <span className="mr-2">{t('access_key.secret_key_doc')}</span>
                <ArrowRightOutlined />
              </a>
            </div>

            <div className='mt-6'>
              {
                [0, 1, 2, 3, 4].map((n) => <div
                  className={`flex mb-2 ${n === 0 ? 'text-danger' : 'text-primary'}`}
                  key={n}
                >
                  <div>
                    <CheckCircleOutlined style={{ fontSize: 14 }}/>
                  </div>
                  <p className='ml-2'>
                    {t(`access_key.ip_restriction_notes.note${n}`)}
                  </p>
                </div>)
              }
            </div>
          </div>
          <div>
            <Checkbox checked={alreadySaved} onChange={(e) => setAlreadySaved(e.target.checked)}>
              {t('access_key.already_saved')}
            </Checkbox>
          </div>
        </div>
      </Drawer>
    </div>
  );
}

export default FormData;
